import createRestfulModule from './restful-module'
import { actionClient, restfulClient } from '@/api'

export default createRestfulModule({

  state: {
    path: 'member/personal/orders', // 资源路径
    defaultRels: ['orderProducts', 'activity', 'orderInvoices', 'refundRecord'], // 默认需要的关联数据
    defaultQuery: {} // 默认的通用查询
  },

  actions: {
    async loadRefundOrders({ commit }, { pagination = {} } = {} ){
      const data = await actionClient.get('member/personal/refund-order', {
        query: {
            page: pagination.currentPage ? pagination.currentPage : 1,
            limit: pagination.limit ? pagination.limit : 6
        }
        
      })
      commit('setCollection', {
        ...data,
        meta: {
          pagination: data.pagination,
          total: data.pagination.total
        }
      })
    }, 
  }

})
